import styled from 'styled-components'

import { Link } from '@src/components/Router/Link'

export const StyledLink = styled(Link)`
  all: unset;
`
